import { PLAYER } from "../../../common/constants.ts";
import type { Player } from "../../../common/types.ts";
import { idb } from "../../db/index.ts";

export const ownerTid = (p: Pick<Player, "tid" | "minorTid">) =>
	p.tid === PLAYER.MINORS ? p.minorTid : p.tid;

export const organizationPlayers = async (tid: number) => {
	const [active, minors] = await Promise.all([
		idb.cache.players.indexGetAll("playersByTid", tid),
		idb.cache.players.indexGetAll("playersByTid", PLAYER.MINORS),
	]);
	return [...active, ...minors.filter((p) => p.minorTid === tid)];
};

// An organization's real prospects: its most valuable minor leaguers. Trade searches only ask for these, and the trade
// screens list them apart from the rest of the farm system (depth, only useful to close a deal).
export const MAX_MINORS_ASSETS = 10;
export const minorsProspects = (players: Pick<Player, "pid" | "tid" | "value">[]) =>
	new Set(
		players
			.filter((p) => p.tid === PLAYER.MINORS)
			.sort((a, b) => b.value - a.value || a.pid - b.pid)
			.slice(0, MAX_MINORS_ASSETS)
			.map((p) => p.pid),
	);
